module.exports = __webpack_public_path__ + "media/48.0d11fa67.mp3";